import Flickity from 'flickity';

export default class SubSectionScroll {
    constructor() {
        this._currentSectionNum = 0;
        this._subSectionsMain = Array.from(document.querySelectorAll('.section-switch'));
        this._subSectionsSub = Array.from(document.querySelectorAll('.section-sub-switch'));
        this._subSectionsSubNav = Array.from(document.querySelectorAll('.section__sub-nav'));
        this._sectionsContent = Array.from(document.querySelectorAll('.section__content'));
        this._navBlock = document.querySelector('.section-nav__content');
        this._navBlockContainer = document.querySelector('.sections');
        this._navHeight = 150;
        this._isMobile = true;
        this._navState = {};
    }

    setupStateFromUrl() {
        // if we have parameters in url, we set them in object
        // else we use the main default for section
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let section = urlParams.get('section');
        let sub = urlParams.get('sub');
        let shouldReplace = false;
        let shouldScroll = true;

        if (!section) {
            // no section is set
            const firstSection = document.querySelector('.section-switch');
            section = firstSection.getAttribute('data-ref');
            try {
                sub = firstSection.parentNode.querySelector('.section-sub-switch').getAttribute('data-ref');
            } catch (e) {
                sub = 0;
            }
            // replace the current state
            shouldReplace = true;
            shouldScroll = false;
        } else {
            if (!sub) {
                try {
                    sub = document
                        .querySelector('.section-switch[data-ref="' + section + '"]')
                        .parentNode.querySelector('.section-sub-switch')
                        .getAttribute('data-ref');
                } catch (e) {
                    sub = 0;
                }
                shouldReplace = true;
            }
        }
        this._navState = { section: section, sub: sub };
        if (shouldReplace) {
            history.replaceState(this._navState, this._documentTitle, this.getQueryString());
        }
        return shouldScroll;
    }

    getQueryString() {
        return (
            '?' +
            Object.keys(this._navState)
                .map((key) => `${key}=${this._navState[key]}`)
                .join('&')
        );
    }

    render() {
        if (this._subSectionsMain.length) {
            this._documentTitle = document.title;
            this.setupHistoryListener();
            if (this.setupStateFromUrl()) this.handleStateChange();
            this._subSectionsMain.forEach((item) => {
                item.addEventListener('click', (e) => {
                    const thisSection = e.currentTarget;
                    if (!thisSection.classList.contains('active')) {
                        // we change main section
                        const section = thisSection.getAttribute('data-ref');
                        const sub = thisSection.parentNode.querySelector('.section-sub-switch')
                            ? thisSection.parentNode.querySelector('.section-sub-switch').getAttribute('data-ref')
                            : 0;
                        this._navState = { section: section, sub: sub };
                        history.pushState(this._navState, this._documentTitle, this.getQueryString());
                        this.handleStateChange();
                    }
                    e.preventDefault();
                });
            });

            this._subSectionsSub.forEach((item) => {
                item.addEventListener('click', (e) => {
                    const thisSubSection = e.currentTarget;
                    if (!thisSubSection.classList.contains('active')) {
                        // we change main section
                        const sub = thisSubSection.getAttribute('data-ref');
                        this._navState.sub = sub;
                        history.pushState(this._navState, this._documentTitle, this.getQueryString());
                        this.handleStateChange();
                    }
                    e.preventDefault();
                });
            });

            var scroll = document.querySelector('.section__nav');
            var flickity = new Flickity(scroll, {
                cellAlign: 'left',
                freeScroll: true,
                prevNextButtons: false,
                pageDots: false,
                contain: true,
                watchCSS: true,
            });

            flickity.on('dragStart', () =>
                Array.from(flickity.slider.childNodes).forEach((slide) => (slide.style.pointerEvents = 'none')),
            );
            flickity.on('dragEnd', () =>
                Array.from(flickity.slider.childNodes).forEach((slide) => (slide.style.pointerEvents = 'all')),
            );

            // make navigation sticky
            window.addEventListener('resize', this.doResize.bind(this));
            this.doResize();
            window.addEventListener('scroll', this.doScroll.bind(this));
            this.doScroll();
        }
    }

    setupHistoryListener() {
        window.addEventListener('popstate', (e) => {
            this.setupStateFromUrl();
            this.handleStateChange();
        });
    }

    handleStateChange() {
        this.openSubNav(this._navState.section);
        this.scrollToSubNav(this._navState.section, this._navState.sub);
    }

    doResize() {
        const willMobile = window.innerWidth < 960;
        if (willMobile != this._isMobile) {
            this._isMobile = willMobile;
            if (!this._isMobile) this.updateSubNavPosition();
        }
    }
    outerHeight(el) {
        let height = el.offsetHeight;
        const style = getComputedStyle(el);

        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
    }

    doScroll() {
        this.updateSubNavPosition();
    }

    updateSubNavPosition() {
        let topPosition = 0;

        if (!this._isMobile) {
            const contentDiv = document.querySelector('.section__content[data-ref="' + this._navState.section + '"]');
            contentDiv.style.minHeight = this._navBlock.getBoundingClientRect().height + 'px';
            const footer = document.querySelector('footer');
            const footerTop = this.offset(footer).top;
            const colTop = this.offset(this._navBlockContainer).top - this._navHeight;
            const colHeight = this.outerHeight(document.querySelector('.section__nav')) + this._navHeight + 20;
            const winHeight = window.innerHeight;
            const thisScroll = window.scrollY;
            if (thisScroll > colTop) {
                this._navBlock.classList.add('fixed');
                if (footerTop < thisScroll + colHeight) {
                    topPosition += footerTop - (thisScroll + colHeight);
                }
            } else {
                this._navBlock.classList.remove('fixed');
            }
            this.updateSubNavState();
        } else {
            this._navBlock.classList.remove('fixed');
        }
        this._navBlock.style.marginTop = topPosition + 'px';
    }

    offset(el) {
        if (el) {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
        } else {
            return { top: 0, left: 0 };
        }
    }

    scrollToSubNav(sectionId, itemId) {
        const target = document.querySelector(
            '.section__content[data-ref="' + sectionId + '"] div[data-row-id="' + itemId + '"]',
        );
        const rect = this.offset(target);
        this.doScrolling(rect.top - this._navHeight, 1000);
    }

    hasPassedViewport(item) {
        const offset = this.offset(item);
        const thisScroll = window.scrollY - 30;
        const winHeight = window.innerHeight;
        return offset.top <= thisScroll + winHeight;
    }

    updateSubNavState() {
        // light current sub nav item according to scroll position + resize
        this._subSectionsSubNav.forEach((item) => {
            let visibleItem = -1;
            const buttons = Array.from(item.querySelectorAll('.section-sub-switch'));
            buttons.forEach((button) => {
                const main = button.getAttribute('data-main');
                const ref = button.getAttribute('data-ref');
                // is this section visible?
                const target = document.querySelector(
                    '.section__content[data-ref="' + this._navState.section + '"] div[data-row-id="' + ref + '"]',
                );
                if (main == this._navState.section && target && this.hasPassedViewport(target)) {
                    visibleItem = ref;
                }
                button.classList.remove('active');
            });

            if (visibleItem != -1) {
                document
                    .querySelector(
                        '.section-sub-switch[data-main="' +
                            this._navState.section +
                            '"][data-ref="' +
                            visibleItem +
                            '"]',
                    )
                    .classList.add('active');
            }
        });
    }

    openSubNav(itemId) {
        if (itemId === this._currentSectionNum) return;
        this._currentSectionNum = itemId;

        this._subSectionsMain.forEach((item) => {
            item.classList.remove('active');
        });
        this._sectionsContent.forEach((item) => {
            item.classList.add('hidden');
        });
        document.querySelector('.section-switch[data-ref="' + itemId + '"]').classList.add('active');
        const contentDiv = document.querySelector('.section__content[data-ref="' + itemId + '"]');
        contentDiv.classList.remove('hidden');
        if (!this._isMobile) {
            const rect = this.offset(contentDiv);
            const thisScroll = window.scrollY;
            if (thisScroll > rect.top - this._navHeight) {
                this.doScrolling(rect.top - this._navHeight, 250);
            }
            this.updateSubNavState();
        }
        let resizeEvent = window.document.createEvent('UIEvents');
        resizeEvent.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(resizeEvent);
    }

    doScrolling(elementY, duration) {
        var startingY = window.pageYOffset;
        var diff = elementY - startingY;
        var start;
        // Bootstrap our animation - it will get called right before next frame shall be rendered.
        window.requestAnimationFrame(function step(timestamp) {
            if (!start) start = timestamp;
            // Elapsed milliseconds since start of scrolling.
            var time = timestamp - start;
            // Get percent of completion in range [0, 1].
            var percent = Math.min(time / duration, 1);
            window.scrollTo(0, startingY + diff * percent);
            // Proceed with animation as long as we wanted it to.
            if (time < duration) {
                window.requestAnimationFrame(step);
            }
        });
    }
}
